var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showFilter":true,"showSearch":true,"showExportation":true,"showAddBtn":false}},[_vm._v("السائقين")]),_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.VUE_APP_TRANSPORTATION_LINK,"status-url":'drivers/status',"list_url":'drivers'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }